import API from "@/api/UserAPI";
import store from "@/store";

export const typesForKeycloak = {
  founderID: {text: 'founder', roles: ['FOUNDER_ROLE', 'CO_ROLE']},
  regionID: {text: 'region', roles: ['REGION_ROLE']},
  orgID: {text: 'org', roles: ['ORGANIZATION_ROLE']}
}
export const typesContact = {
  founder: 'founder',
  co: 'founder',
  region: 'region',
  org: 'org'
}

/**
 * @param {'founder' | 'region' | 'organisation'} [typeContact]
 * */
export function typeRequestNameForApi(typeContact) {

  if (store.getters['keycloak/getFakeUser'])
    typeContact = Object.values(typesForKeycloak).find(el => el.roles.includes(store.getters['keycloak/getFakeUser'].role))?.text ?? typeContact
  else {
    const keys = Object.keys(store.getters['keycloak/getAuthData']);
    for (const key of keys) {
      if (typesForKeycloak[key]) {
        typeContact = typesForKeycloak[key].text;
        break;
      }
    }
  }

  return typeContact
}

export function idUserForApi(id) {
  if (store.getters['keycloak/getFakeUser']) {
    id = store.getters['keycloak/getFakeUser'].id
  } else {
    const keys = Object.keys(store.getters['keycloak/getAuthData']);
    for (const key of keys) {
      if (typesForKeycloak[key]) {
        id = store.getters['keycloak/getAuthData'][key] ?? id;
        break;
      }
    }
  }
  return id
}

class UserController {
  // api = UserAPI;
  typesContact = {
    founder: 'founder',
    co: 'founder',
    region: 'region',
    org: 'org',
  }

  constructor() {
    this.api = API
  }

  _checkTypeContact(typeContact) {
    if (!this.typesContact[typeContact])
      throw new Error(`${typeContact}: type contact invalid can be founder or region;`);
  }

  _checkId(id) {
    if (!id)
      throw new Error(`id: ${id} cannot be null`);
  }

  /**
   * @param { 'founder' | 'region' | 'org'} [type]
   * @param { Number | null| undefined } [id]
   * */
  async getBlockInfo(type, id) {
    try {
      type = type ?? typeRequestNameForApi(type);
      id = idUserForApi(id);
      this._checkId(id);
      this._checkTypeContact(type);
      let res;
      if (type === 'org') { //404 на орг 4 (уфимский)
        res = await this.api.getBlockOrganizationInfo(id);
      } else {
        res = await this.api.getBlockInfo(type, id);
      }
      return res.data;
    } catch (e) {
      console.error('error getBlockInfo ' + e.message)
      throw new Error('error getBlockInfo ' + e.message)
    }
  }

  /**
   * @param {'founder'| 'region'} [type]
   * @param {Number | null| undefined} [id]
   * */
  async getBlockAllowInfo(type, id) {
    try {
      type = typeRequestNameForApi(type);
      id = idUserForApi(id);
      this._checkId(id);
      this._checkTypeContact(type);
      const res = await this.api.getBlockAllowInfo(type, id);
      return res.data;
    } catch (e) {
      console.error('error getBlockAllowInfo ' + e)
      throw new Error('error getBlockAllowInfo ' + e)
    }
  }

  /**
   * @param {'founder'| 'region'} type
   * @param {1 | 2 | 3} stageId
   * @param {Number | null| undefined} [id]
   * */
  async setBlock(type, stageId, id) {
    try {
      type = type ?? typeRequestNameForApi(type);
      id = id ?? idUserForApi(id);
      this._checkId(id);
      this._checkTypeContact(type);
      const res = await this.api.setBlock(type, stageId, id);
      await store.dispatch('spr/changeBlockInfo', {...res.data, name: type});
      return res.data;
    } catch (e) {
      console.error('error setBlock ' + e)
      throw new Error('error setBlock ' + e)
    }
  }

  /**
   * @param {boolean} value
   * @param {'ORG_BLOCK' | 'KONVERT_BLOCK'} type
   * @param {Number | null| undefined} [id]
   * */
  async setBlockOrganization(value = true, type, id) {
    try {
      id = id ?? idUserForApi(id);
      this._checkId(id);
      // const res1 = await this.api.checkForBlockOrg(id);
      // console.log(res1.data);
      const res = await this.api.setBlockOrg(type, value, id);
      if (!res.data.hasErrors && store.getters['keycloak/userId']) {
        await store.dispatch('checkFilled/updateBlockOrganizationInfo', res.data);
      }
      return res.data;
    } catch (e) {
      console.error('error setBlockOrganization ' + e.message)
      throw new Error('error setBlockOrganization ' + e.message)
    }
  }

  async valuesCheck(id) {
    try {
      id = id ?? idUserForApi(id);
      this._checkId(id);
      const res = await this.api.checkForBlockOrg(id);
      if (!res.data.hasErrors && store.getters['keycloak/userId']) {
        await store.dispatch('checkFilled/updateBlockOrganizationInfo', res.data);
      }
      return res.data;
    } catch (e) {
      console.error('error setBlockOrganization ' + e.message)
      throw new Error('error setBlockOrganization ' + e.message)
    }
  }

  /**
   * @param {'founder'| 'region'} type
   * @param {1 | 2 | 3} stageId
   * @param {Number | null| undefined} id
   * */
  async unBlock(type, stageId, id) {
    try {
      type = type ?? typeRequestNameForApi(type);
      id = id ?? idUserForApi(id);
      this._checkId(id);
      this._checkTypeContact(type);
      const res = await this.api.unBlock(type, stageId, id);
      await store.dispatch('spr/changeBlockInfo', {...res.data, name: type});
      return res.data;
    } catch (e) {
      console.error('error unBlock ' + e)
      throw new Error('error unBlock ' + e)
    }
  }
}

export default new UserController()